import { FooterSchema } from './Footer.styles';
import footer from '@/assets/wellbet/images/footer/footer.png';

export const footerStyles: FooterSchema = {
  footer: {
    mt: '6',
    bg: ['gray.200', null, 'transparent'],
    bgImage: [`url(${footer})`, null, ''],
    bgSize: 'cover',
    bgPos: 'bottom',
    color: 'white',
  },
  stackGap: '1',
  footerBar: {
    display: 'flex',
    flexDir: ['column', null, 'row'],
    h: '70px',
    pr: '0',
    mb: '8',
    borderRadius: 'md',
    alignItems: 'center',
    justifyContent: ['center', null, 'unset'],
    sx: {
      '& > img': {
        maxW: '250px',
        h: '35px',
        ml: '0',
      },
    },
  },
  footerLink: {
    color: 'gamma.500',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
  },
  footerLinkTel: {
    color: 'gamma.500',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
  },
  footerLinkService: {
    color: 'gamma.500',
    fontSize: 'md',
  },
  customFooterLink: {
    color: 'gamma.500',
    textTransform: 'capitalize',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '-1px',
    whiteSpace: 'nowrap',
    fontSize: 'sm',
  },
  footerLinks: {
    mt: '3',
    ml: ['unset', null, 'auto'],
    pb: ['4', null, '0'],
    alignItems: 'center',
    justifyContent: ['space-around', null, 'unset'],
    color: 'white',
    fontWeight: 'medium',
    flexDir: ['row', null, 'unset'],
    display: 'inline-flex',
  },
  footerContentContainer: {
    px: ['2.5', 'unset'],
    gap: ['2', '6'],
    bg: [null, null, 'transparent'],
    justifyContent: 'space-between',
    sx: {
      '&': {
        flexDirection: 'column',
      },
    },
  },
  nav: {
    fontSize: 'sm',
    fontWeight: 'medium',
    minW: [null, null, '370px'],
    display: ['flex', 'grid'],
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: 'auto',
    columnGap: '28',
    rowGap: ['0', '1'],
    alignItems: ['center', 'end'],
    gridTemplateAreas: `
      ". ."
    `,
    sx: {
      '> a': {
        color: 'alpha.200',
      },
    },
  },
  LinkText: {
    color: 'alpha.200',
  },
  blurb: {
    flex: 'unset',
    textAlign: ['center', 'left'],
    color: 'alpha.200',
    width: 'unset',
    mb: '0',
    ml: [null, '0'],
    mr: [null, null, '4'],
  },
  blurbHeading: {
    ml: 'unset',
    mt: 'unset',
  },
  blurbHeadingAge: {
    borderColor: 'alpha.200',
    border: '4px',
    mb: '2',
    boxSize: '8',
    fontSize: 'xs',
    color: 'alpha.200',
  },
  blurbHeadingThink: {
    fontSize: 'xs',
    fontWeight: 'bold',
    mb: '3',
    color: 'alpha.200',
  },
  blurbContent: {
    ml: 'unset',
    mr: [null, null, 'auto'],
  },
  copyright: {
    textAlign: ['center', 'left'],
    mt: ['6'],
    px: ['8', 'unset'],
    py: '0',
    fontWeight: ['semibold', 'medium'],
    color: 'alpha.200',
  },
  container: {
    sx: {
      '&&': {
        px: '0',
      },
    },
  },
  quickLinks: {
    fontSize: 'sm',
    textAlign: ['center', 'left'],
    textTransform: 'uppercase',
    pb: ['2', '0'],
  },
  ourPartners: {
    fontSize: 'sm',
    textTransform: 'uppercase',
    pb: '2',
  },
  weAccept: {
    fontSize: 'sm',
    textTransform: 'uppercase',
    pb: '2',
  },
  weAcceptBox: {
    mb: '2',
  },
  emailUs: {
    fontSize: 'md',
    fontWeight: 'bold',
    color: 'alpha.200',
  },
  ButtonPdf: {
    color: 'alpha.200',
  },
};
